import { ContentfulLivePreview } from "@contentful/live-preview";

let isInitialized = false;
let initPromise;

export async function initializeContentfulPreview(isPreview) {
  if (!isPreview) {
    return;
  }

  if (isInitialized) {
    return initPromise;
  }

  // Initialize Contentful Live Preview
  initPromise = await ContentfulLivePreview.init({
    locale: "en-US",
    enableInspectorMode: true,
    debugMode: false
  });
  isInitialized = true;
  return initPromise;
}

export function livePreviewSubscribe(isPreview, pageTemplateRecord, setterFunction) {
  if (!isPreview) {
    return;
  }
  // eslint-disable-next-line
  for (const [fieldId, _] of Object.entries(pageTemplateRecord.fields)) {
    setupLivePreview(pageTemplateRecord, fieldId);
  }

  function setupLivePreview(entry, fieldId) {
    const callback = (updatedData) => {
      setterFunction(fieldId, updatedData.fields[fieldId]);
    };

    ContentfulLivePreview.subscribe({
      data: entry,
      locale: "en-US",
      callback
    });
  }
}
